module.exports = __webpack_public_path__ + "img/hourglass.4700993c.svg";